import React, { useEffect } from 'react'
import Layout from '../../brands/components/Layout'
import DataGrid from 'react-data-grid'
import { Icon } from '@iconify/react'
import { useNavigate } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import { getAllForms } from '../api'
import { formatDateAndTime } from '../../resources/empresources/utils'
import DelForm from '../components/DelFormModal'
import { useAppDispatch, useAppSelector } from '../../../redux/hook'
import { saveFormList } from '../slice/formslice'
import { HIDE_LOADER, SHOW_LOADER } from '../../../redux/slices/LoaderSlice'

interface FormValues {
    formId: string
    title: string
    status: string
    createdOn: string
    formStats: {
        completedBy: string[]
        assignedTo: string[]
    }
}

interface FormsState {
    formList: FormValues[]
}

interface RootState {
    forms: FormsState
}

const Forms: React.FC = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const forms = useAppSelector((state: RootState) => state.forms.formList)
    const [deleteForm, setDeleteForm] = React.useState(false)
    const [formId, setFormId] = React.useState<string>('')

    const column = [
        {
            key: 'title',
            name: 'Title',
            resizable: true,
            sortable: true,
            // flexGrow: 1,
        },
        {
            key: 'formStats',
            name: 'Status',
            resizable: true,
            sortable: true,
            width: 100,
            renderCell: (e: {
                row: {
                    formStats: { completedBy: string[]; assignedTo: string[] }
                }
            }) => {
                const completedBy = e?.row?.formStats?.completedBy
                return (
                    <div className="dropdown-custom-link">
                        <Dropdown>
                            <Dropdown.Toggle
                                variant="success"
                                id="dropdown-basic"
                            >
                                <Icon icon="mdi:eye" className="icon-success" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item className="disabled-dropdown-item ">
                                    <b>Completed by</b>
                                </Dropdown.Item>
                                {completedBy?.map(
                                    (name: string, index: number) => (
                                        <Dropdown.Item
                                            key={index}
                                            className="disabled-dropdown-item "
                                        >
                                            {name}
                                        </Dropdown.Item>
                                    )
                                )}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                )
            },
        },
        {
            key: 'createdOn',
            name: 'Created On',
            resizable: true,
            sortable: true,
            width: 200,
        },

        {
            key: 'actions',
            sortable: true,
            name: 'Actions',
            resizable: true,
            width: 100,
            renderCell: (e: {
                row: {
                    title: any
                    formId: string
                }
            }) => {
                return (
                    <>
                        <div className="dropdown-custom-link">
                            <Dropdown>
                                <Dropdown.Toggle
                                    variant="success"
                                    id="dropdown-basic"
                                >
                                    <Icon icon="mage:dots" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item
                                        onClick={() =>
                                            navigate(
                                                `/forms/edit/${e.row.formId}`
                                            )
                                        }
                                    >
                                        Edit
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        onClick={() => {
                                            setFormId(e.row.formId)
                                            setDeleteForm(true)
                                        }}
                                    >
                                        Delete
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        onClick={() =>
                                            navigate('/forms/assign', {
                                                state: {
                                                    id: e.row.formId,
                                                    formName: e.row.title,
                                                },
                                            })
                                        }
                                    >
                                        Assign
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </>
                )
            },
        },
    ]

    function EmptyRowsRenderer() {
        return (
            <div className="no-data-message">
                There are no forms yet.
                <span onClick={handleNoTaskClick} className="click-here">
                    Click here
                </span>{' '}
                to create a new one.
            </div>
        )
    }

    const handleNoTaskClick = () => {
        navigate(`/forms/upload`)
    }

    const getForms = async () => {
        dispatch(SHOW_LOADER())
        const response = await getAllForms()
        response?.data?.data?.sort(
            (a: { createdOn: string }, b: { createdOn: string }) =>
                new Date(b.createdOn).getTime() -
                new Date(a.createdOn).getTime()
        )
        const forms = response?.data?.data.map((form: any) => {
            return {
                formId: form.formId,
                title: form.title,
                createdOn: formatDateAndTime(form.createdOn),
                formStats: form.formStats,
            }
        })
        dispatch(saveFormList({ data: forms }))
        dispatch(HIDE_LOADER())
    }

    useEffect(() => {
        getForms()
    }, [])
    return (
        <div>
            {deleteForm && (
                <DelForm
                    data={{ id: formId }}
                    onClose={setDeleteForm}
                    show={deleteForm}
                />
            )}
            <Layout>
                <div className="col-12 grid-custom-table">
                    <div className="page-information mb-3">
                        <div className="row">
                            <div className="col-sm-6">
                                <h4>Forms</h4>
                            </div>
                            <div className="col-sm-6">
                                <div className="custom-btn-design">
                                    <a
                                        onClick={() => {
                                            navigate('/forms/upload')
                                        }}
                                        className="button button-primary button-align-right"
                                    >
                                        UPLOAD FORM
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <>
                        {forms && forms?.length > 0 ? (
                            <DataGrid
                                className="data-grid-table"
                                columns={column}
                                rows={forms}
                                rowHeight={60}
                                headerRowHeight={40}
                                renderers={{
                                    noRowsFallback: <EmptyRowsRenderer />,
                                }}
                            />
                        ) : (
                            <div className="no-records"></div>
                        )}
                    </>
                </div>
            </Layout>
        </div>
    )
}

export default Forms
